module.exports = __webpack_public_path__ + "img/natural-science.d95064cd.svg";